import { render, staticRenderFns } from "./OmniSearchShow.vue?vue&type=template&id=41e60e78&"
import script from "./OmniSearchShow.vue?vue&type=script&lang=js&"
export * from "./OmniSearchShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports